<template>
  <el-popover
    width="350"
    trigger="hover"
    popper-class="goods-popover"
    :append-to-body="true"
    @show="getCustomerHistorySkuList"
  >
    <div class="goods-wrap" v-loading="loading" :style="{ minHeight: loading ? '200px' : 'auto' }">
      <div class="goods-wrap-list">
        <template v-for="(item, index) in list">
          <div class="goods-wrap-item" :key="index">
            <el-badge :value="item.qty">
              <ZImg :src="item.skuIcon" class="goods-image"></ZImg>
            </el-badge>
            <div class="goods-item-info">
              <div class="title">
                {{ $dataCheck(item.spuName) }}
              </div>
              <p style="margin-top: 8px">{{ $dataCheck(item.skuAttr) }}</p>
              <p style="margin-top: 8px">物流状态：{{ $dataCheck(item.orderSubStatus) }}</p>
              <!-- <div>
                <p style="margin-top:8px;">SKU: {{ $dataCheck(item.skuId) }}</p>
              </div> -->
            </div>
          </div>
        </template>
      </div>
    </div>
    <el-button style="padding: 5px" v-show="row.qty" slot="reference">...</el-button>
  </el-popover>
</template>

<script>
import { filterVariant } from '@/utils/utils'
import { getCustomerHistorySkuList } from '@/server/etl'
export default {
  name: 'order-goods',
  props: {
    row: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      goodsList: [],
      loading: false,
    }
  },
  computed: {
    list() {
      return this.goodsList || []
    },
  },
  mounted() {},
  methods: {
    filterVariant,
    async getCustomerHistorySkuList() {
      this.loading = true
      const { data } = await getCustomerHistorySkuList({
        orgUnitId: this.$store.state.user.merchantId,
        orderNo: this.row.orderNo,
      })
      this.loading = false
      if (data.code === this.$code) {
        this.goodsList = data.data.datas
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.goods-wrap {
  .goods-wrap-item {
    padding: 24px;
    display: flex;
    .goods-image {
      width: 64px;
      height: 64px;
      border-radius: 5px;
      border: 1px solid #d9d9d9;
    }
    .goods-item-info {
      margin-left: 24px;
      font-size: 12px;
      color: #666666;
      flex: 1;
      .title {
        font-size: 14px;
        font-weight: bold;
        color: #010517;
        width: 200px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        word-wrap: break-word;
      }
    }
  }
  .goods-wrap-item + .goods-wrap-item {
    border-top: 1px solid #ebeef5;
  }
  .goods-item-info {
    // height: 64px;
    display: flex;
    flex-direction: column;
    // justify-content: space-between;
  }
  .goods-wrap-list {
    overflow: auto;
    max-height: 350px;
  }
}
</style>
<style>
.goods-popover {
  padding: 0px !important;
}
</style>
